import styled, { css } from 'styled-components'
import { fontSize } from '../../../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

import FormInput from 'components/UI/FormInput/FormInput'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`

export const StyledFormInput = styled(FormInput)`
  margin-left: 5px;
  margin-right: 5px;
  font-size: ${fontSize.small};
`
